import { render, staticRenderFns } from "./TaskTypeItem.vue?vue&type=template&id=d0ab977a&"
import script from "./TaskTypeItem.vue?vue&type=script&lang=js&"
export * from "./TaskTypeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports